import {
  Box,
  ClearIcon,
  Dialog,
  DialogContent,
  Slide,
  Stack,
  styledComponent,
  Typography,
  TypographyProps
} from '@hermes/web-components'
import { PropsWithChildren } from 'react'

type MobileDetailsModalProps = {
  isOpen: boolean
  onClose: () => void
  heading: string
  withPadding?: boolean
  headingProps?: TypographyProps
}

const StyledDialog = styledComponent(Dialog)(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    '& .MuiDialog-container': {
      alignItems: 'flex-end'
    },
    '& .MuiDialog-paper': {
      backgroundColor: 'transparent',
      margin: 0,
      width: '100%',
      borderRadius: 0,
      maxHeight: '100%'
    },
    '& .MuiDialogContent-root': {
      width: '100%'
    }
  }
}))

export const MobileDetailsModal = ({
  isOpen,
  heading,
  onClose,
  children,
  headingProps,
  withPadding = true
}: PropsWithChildren<MobileDetailsModalProps>) => (
  <StyledDialog open={isOpen} onClose={onClose} maxWidth="lg">
    <Slide direction="up" in={isOpen} timeout={500}>
      <Box
        bgcolor={'common.white'}
        sx={{
          borderTopLeftRadius: '15px',
          borderTopRightRadius: '15px'
        }}
      >
        <DialogContent
          sx={{
            py: 2,
            px: withPadding ? 2 : 0,
            width: '100%',
            backgroundColor: 'white.100',
            position: 'relative'
          }}
        >
          <Stack direction="row" justifyContent="space-between" mb={2} sx={{ px: withPadding ? 0 : 2 }}>
            <Typography {...headingProps}>{heading}</Typography>
            <button
              style={{ border: 'none', backgroundColor: 'inherit', display: 'flex', alignItems: 'center' }}
              onClick={onClose}
            >
              <ClearIcon />
            </button>
          </Stack>
          {children}
        </DialogContent>
      </Box>
    </Slide>
  </StyledDialog>
)
